import type { INoteData, INote } from '../';
import type { IALMResource, IALMResourceData } from '../';
export interface IModule extends IModuleData {
  isUploadable: boolean;
  notes?: INote[];
  resources?: IALMResource[];
  validate(): void;
}

export interface IModuleData {
  id: string;
  courseId: string;
  instanceId: string;
  hasPassed: boolean;
  contentType: ModuleContentTypes;
  moduleType: string;
  progress: number;
  durationInMinutes: number;
  name: string;
  description: string;
  notes?: INoteData[];
  isSubmissible: boolean;
  mandatory: boolean;
  resources?: IALMResourceData[];
}

export enum ModuleContentTypes {
  Content = 'Content',
  TestOut = 'Test Out',
  PreWork = 'Pre Work'
}
